<template>
  <div>
    <PageHeader>
      <template v-slot:header>{{ totalTargetTitleMain }}、他</template>
    </PageHeader>

    <v-form ref="total_form">
      <div style="text-align: left; padding: 0px 0px 0px 0px">
        <p>
          <small>※総合目標等のタイトルを変更します。</small>
        </p>
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="3" lg="2" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="総合目標タイトル"
            v-model="totalTargetTitle"
            rules="required"
            :counter="10"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="振り返りタイトル"
            v-model="commentTitle"
            rules="required"
            :counter="10"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" lg="2" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="最終確認タイトル"
            v-model="lastConfirmTitle"
            rules="required"
            :counter="10"
            v-bind:disabled="!isEdit"
          />
        </v-col>
      </v-row>
      <div style="text-align: left; padding: 0px 0px 0px 0px">
        <p><small>※総合目標のサブタイトルを変更します。</small></p>
      </div>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="総合目標サブタイトル1"
            v-model="totalGoalTitle1"
            rules="required"
            :counter="50"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="総合目標サブタイトル2"
            v-model="totalGoalTitle2"
            rules="required"
            :counter="50"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="総合目標サブタイトル3"
            v-model="totalGoalTitle3"
            rules="required"
            :counter="50"
            v-bind:disabled="!isEdit"
          />
        </v-col>
      </v-row>
      <div style="text-align: left; padding: 0px 0px 0px 0px">
        <p>
          <small
            >※「振り返りと次月への取り組み」の課題<strong>(自己)</strong>タイトルを変更します。</small
          >
        </p>
      </div>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="課題自己_タイトル1"
            v-model="taskSelfTitle1"
            rules="required"
            :counter="20"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="課題自己_タイトル2"
            v-model="taskSelfTitle2"
            rules="required"
            :counter="20"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="課題自己_タイトル3"
            v-model="taskSelfTitle3"
            rules="required"
            :counter="20"
            v-bind:disabled="!isEdit"
          />
        </v-col>
      </v-row>
      <div style="text-align: left; padding: 0px 0px 0px 0px">
        <p>
          <small
            >※「振り返りと次月への取り組み」の課題<strong>(管理者)</strong>タイトルを変更します。</small
          >
        </p>
      </div>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="課題管理_タイトル1"
            v-model="taskManageTitle1"
            rules="required"
            :counter="20"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="課題管理_タイトル2"
            v-model="taskManageTitle2"
            rules="required"
            :counter="20"
            v-bind:disabled="!isEdit"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="4" class="pt-0 pb-0 pl-3 pr-0">
          <FormInputComponent
            label="課題管理_タイトル3"
            v-model="taskManageTitle3"
            rules="required"
            :counter="20"
            v-bind:disabled="!isEdit"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="6" md="4" lg="2" class="pt-0 pb-0 pl-3 pr-0">
          <Button v-if="isEdit" @click="change_confirm" color="primary"
            >更新</Button
          >
        </v-col>
      </v-row>
    </v-form>

    <ConfirmDialog
      ref="confirm"
      :title="totalTargetTitleMsg"
      :message="confirmMessage"
      buttonMessage="OK"
      @confirm="changeEvaluationInfo"
    >
    </ConfirmDialog>
    <DialogMessage ref="dialog" />
  </div>
</template>

<script>
import ConfirmDialog from '@/components/Common/ConfirmMessage.vue';
import message from '../../../message.js';
import axios from 'axios';
import config from '../../../const.js';
import moment from 'moment';
import { getSessionStorageItem, getStrByteLength } from '../../../common.js';
export default {
  components: {
    ConfirmDialog,
  },
  props: {
    goalId: {
      type: String,
      required: true,
    },
    gradeId: {
      type: String,
      required: true,
    },
    periodStatus: {
      type: [String, String],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      confirm: false,
      confirmMessage: null,
      evalStatus: '',
      isEdit: false,
      userInfo: {},
      totalTargetTitleMain: '',
      totalTargetTitleMsg: '',
      totalTargetTitle: '',
      commentTitle: '',
      lastConfirmTitle: '',
      totalGoalTitle1: '',
      totalGoalTitle2: '',
      totalGoalTitle3: '',
      taskSelfTitle1: '',
      taskSelfTitle2: '',
      taskSelfTitle3: '',
      taskManageTitle1: '',
      taskManageTitle2: '',
      taskManageTitle3: '',
    };
  },
  created() {
    const userInfo = getSessionStorageItem();
    this.userInfo = userInfo;

    // 活性・非活性制御
    this.isEdit = false;
    if (
      this.periodStatus == config.PERIOD_STATUS_BEFORE_GOAL ||
      this.periodStatus == config.PERIOD_STATUS_MAKE_GOAL
    ) {
      // 年度の状態が「0:目標作成前」、「1:目標作成」の場合に活性
      this.isEdit = true;
    }

    this.getEvaluationItems();
  },
  methods: {
    change_confirm() {
      // 入力チェック
      if (!this.$refs.total_form.validate()) {
        return;
      }
      var infoStr = '';
      var infoStrReplace = '';
      var totalGoalTitleMaxLength = config.TOTAL_GOAL_TITLE_MAX_LENGTH * 3;

      // 総合目標タイトル１
      if (getStrByteLength(this.totalGoalTitle1) > totalGoalTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '総合目標タイトル1');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }
      // 総合目標タイトル２
      if (getStrByteLength(this.totalGoalTitle2) > totalGoalTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '総合目標タイトル2');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }
      // 総合目標タイトル３
      if (getStrByteLength(this.totalGoalTitle3) > totalGoalTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '総合目標タイトル3');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }

      var taskTitleMaxLength = config.TASK_TITLE_MAX_LENGTH * 3;

      // 課題自己タイトル１
      if (getStrByteLength(this.taskSelfTitle1) > taskTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '課題自己タイトル1');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }
      // 課題自己タイトル２
      if (getStrByteLength(this.taskSelfTitle2) > taskTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '課題自己タイトル2');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }
      // 課題自己タイトル３
      if (getStrByteLength(this.taskSelfTitle3) > taskTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '課題自己タイトル3');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }

      // 課題管理タイトル１
      if (getStrByteLength(this.taskManageTitle1) > taskTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '課題管理タイトル1');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }
      // 課題管理タイトル２
      if (getStrByteLength(this.taskManageTitle2) > taskTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '課題管理タイトル2');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }
      // 課題管理タイトル３
      if (getStrByteLength(this.taskManageTitle3) > taskTitleMaxLength) {
        infoStr = message.MSG_INFO_TOTAL_GOAL_TITLE_LENGTH_NG;
        infoStrReplace = infoStr.replace(/a/g, '課題管理タイトル3');
        this.$refs.dialog.open('info', infoStrReplace);
        return;
      }

      // 確認ダイアログ表示
      this.confirmMessage = this.totalTargetTitleMain + '情報を更新しますか？';
      this.$refs.confirm.open();
    },
    changeEvaluationInfo() {
      // セッションチェック
      let userInfo = getSessionStorageItem();
      if (userInfo == null) {
        this.$refs.dialog.open(
          'error',
          message.MSG_ERROR_SESSION + message.MSG_ERROR_SESSION_DETAIL
        );
        this.loading = false;
        return;
      }
      // 総合目標、他情報更新
      this.changeTotalGoalInfoRequest();
    },
    changeTotalGoalInfoRequest() {
      // ローディング画像表示
      this.loading = true;
      // ユーザ情報の取得
      let userInfo = getSessionStorageItem();
      // 共通
      this.updateAt = moment().format('YYYYMMDDHHmmss');

      //----- 総合目標、他情報更新リクエストPOST
      axios
        .post(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/totalgoal/update',
          {
            SESSION_ID: userInfo.SESSION_ID,
            SESSION_USER_ID: userInfo.USER_ID,

            GOAL_ID: this.goalId,
            GRADE_ID: this.gradeId,
            TOTAL_TARGET_TITLE: this.totalTargetTitle,
            COMMENT_TITLE: this.commentTitle,
            LAST_CONFIRM_TITLE: this.lastConfirmTitle,

            TOTAL_GOAL_TITLE_1: this.totalGoalTitle1,
            TOTAL_GOAL_TITLE_2: this.totalGoalTitle2,
            TOTAL_GOAL_TITLE_3: this.totalGoalTitle3,
            TASK_SELF_TITLE_1: this.taskSelfTitle1,
            TASK_SELF_TITLE_2: this.taskSelfTitle2,
            TASK_SELF_TITLE_3: this.taskSelfTitle3,
            TASK_MANAGE_TITLE_1: this.taskManageTitle1,
            TASK_MANAGE_TITLE_2: this.taskManageTitle2,
            TASK_MANAGE_TITLE_3: this.taskManageTitle3,
            UPDATED_AT: this.updateAt,
          }
        )
        .then((response) => {
          // ローディング画像終了
          this.loading = false;

          let msgStr = '';
          if (response.status == 200) {
            msgStr =
              this.totalTargetTitleMain + '、他情報の更新が成功しました。';
            this.$refs.dialog.open('info', msgStr);
          }
        })
        .catch((error) => {
          // ローディング画像終了
          this.loading = false;

          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM_ERROR + error;
            this.$refs.dialog.open('error', errStr);
          }
        });
    },
    async getEvaluationItems() {
      this.loading = true;

      await axios
        .get(
          config.CONNECT_EVALUATIONS_URL +
            '/Evaluations/manages/goal/grade/' +
            this.userInfo.SESSION_ID +
            '/' +
            this.userInfo.USER_ID +
            '/' +
            this.goalId +
            '/' +
            this.gradeId
        )
        .then((response) => {
          // 状態
          this.evalStatus = response.data[0].EVAL_STATUS;
          this.totalTargetTitleMain = response.data[0].TOTAL_TARGET_TITLE;
          this.totalTargetTitleMsg =
            this.totalTargetTitleMain + '、他' + config.MESSAGE_EDIT;
          this.totalTargetTitle = response.data[0].TOTAL_TARGET_TITLE;
          this.commentTitle = response.data[0].COMMENT_TITLE;
          this.lastConfirmTitle = response.data[0].LAST_CONFIRM_TITLE;

          this.totalGoalTitle1 = response.data[0].TOTAL_GOAL_TITLE_1;
          this.totalGoalTitle2 = response.data[0].TOTAL_GOAL_TITLE_2;
          this.totalGoalTitle3 = response.data[0].TOTAL_GOAL_TITLE_3;
          this.taskSelfTitle1 = response.data[0].TASK_SELF_TITLE_1;
          this.taskSelfTitle2 = response.data[0].TASK_SELF_TITLE_2;
          this.taskSelfTitle3 = response.data[0].TASK_SELF_TITLE_3;
          this.taskManageTitle1 = response.data[0].TASK_MANAGE_TITLE_1;
          this.taskManageTitle2 = response.data[0].TASK_MANAGE_TITLE_2;
          this.taskManageTitle3 = response.data[0].TASK_MANAGE_TITLE_3;
        })
        .catch((error) => {
          let errStr = '';
          if (error.status == 400) {
            errStr = message.MSG_ERROR_SESSION + error;
            this.$refs.dialog.open('error', errStr);
          } else {
            errStr = message.MSG_ERROR_SYTEM + error;
            this.$refs.dialog.open('error', errStr);
          }
        });

      this.loading = false;
    },
  },
};
</script>
